import React from "react";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

interface GenderVoteData {
    options: string;
    she_her: number;
    he_him: number;
    they_them: number;
}

interface Props {
    genderVoteData: GenderVoteData[];
}

const GenderVoteDistributionChart: React.FC<Props> = ({ genderVoteData }) => {
    const { t } = useTranslation();
    const options = genderVoteData.map((entry) => entry.options);
    const sheHerData = genderVoteData.map((entry) => entry.she_her);
    const heHimData = genderVoteData.map((entry) => entry.he_him);
    const theyThemData = genderVoteData.map((entry) => entry.they_them);

    const optionsChart = {
        chart: {
            type: "bar" as const,
            height: 350,
        },
        plotOptions: {
            bar: {
                horizontal: true,
                columnWidth: "45%",
                endingShape: "rounded",
            },
        },
        xaxis: {
            categories: options,
            labels: {
                style: {
                    fontSize: "12px",
                },
            },
        },
        yaxis: {
            title: {
                text: t("components.graphs.genderVoteDistribution.yAxis"),
            },
        },
        colors: ["#D549CD", "#2A4971", "#5DC6FF"],
        legend: {
            position: "bottom" as const,
            show: true,
        },
        tooltip: {
            y: {
                formatter: (val: number) =>
                    t("components.graphs.genderVoteDistribution.tooltip", {
                        count: val,
                    }),
            },
        },
        title: {
            align: "center" as const,
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
                fontSize: "18px",
                color: "#263238",
            },
        },
    };

    const series = [
        {
            name: t("components.graphs.genderVoteDistribution.series.she_her"),
            data: sheHerData,
        },
        {
            name: t("components.graphs.genderVoteDistribution.series.he_him"),
            data: heHimData,
        },
        {
            name: t(
                "components.graphs.genderVoteDistribution.series.they_them"
            ),
            data: theyThemData,
        },
    ];

    return (
        <div>
            <ReactApexChart
                options={optionsChart}
                series={series}
                type="bar"
                height={350}
            />
        </div>
    );
};

export default GenderVoteDistributionChart;
